<template>
    <div class="z-accordion">
        <slot />
    </div>
</template>

<script setup>
import { ref, provide, inject, onMounted, computed } from 'vue'
import {useGetter} from '@/composable/useGetter'

const {device} = useGetter(['device'])

const props = defineProps({
    multiple: {
        type: Boolean,
        default: false
    },
    initial: {
        type: String
    },
    setHash: {
        type: Boolean,
        default: true
    },
    size: {
        type: String,
        default: 'l',
        validator: prop => ['l', 'm', 's'].includes(prop)
    }
})

const getSize = computed(() => {
    return device.value === 'mobile' ? 's' : props.size
})

const openedItems = ref([])
const itemsArr = ref([])

const toggleItem = (accId) => {
    if (openedItems.value.includes(accId)){
        openedItems.value.splice(openedItems.value.indexOf(accId), 1)
        if (props.setHash) updateHash('')
        return
    }

    if (!props.multiple) {
        openedItems.value = []
        openedItems.value.push(accId)
    } else {
        openedItems.value.push(accId)
    }

    if (props.setHash) updateHash(accId)
}

const updateHash = (accId) => {
    const hash = accId ? `#${accId}` : ''
    history.pushState({}, '', window.location.pathname + hash)
}

const addItem = (accId) => {
    if (itemsArr.value.includes(accId)) return
    itemsArr.value.push(accId)
}

provide('accordion', {
    toggleItem,
    openedItems,
    addItem,
    size: getSize
})

const parentId = inject('accordion-item')?.itemId
const parentToggleItem = inject('accordion')?.toggleItem

const init = () => {
    const hash = window.location.hash?.replace('#', '')
    if (itemsArr.value?.includes(hash)) {
        if (parentToggleItem && parentId) parentToggleItem(parentId)
        toggleItem(hash)

        return
    }

    if (props.initial && itemsArr.value.includes(props.initial)) {
        toggleItem(props.initial)
        return
    }

    if (props.initial === 'first') {
        toggleItem(itemsArr.value?.[0])
    }
}


onMounted(() => {
    init()
})
</script>

<style lang="scss"></style>
